import type { DealCategoryTreeNode } from 'apis/supplier-prices';
import { findCategoryPath } from 'components/category-picker/category-tree-helpers';
import { Text } from 'design-system';

export interface IFamilyCategoryCell {
  catalogCategoryId: number;
  categoryTree: DealCategoryTreeNode[];
  noOfLines?: number;
}

export const FamilyCategoryCell = ({ catalogCategoryId, categoryTree, noOfLines }: IFamilyCategoryCell) => {
  const path = findCategoryPath(categoryTree, catalogCategoryId);
  const label = path.length ? path.map((n) => n.title || `Untitled (${n.id})`).join(' › ') : `#${catalogCategoryId}`;

  return (
    <Text fontSize='sm' color='gray.700' noOfLines={noOfLines}>
      {label}
    </Text>
  );
};
